import { inject, Injectable } from '@angular/core';
import {
  checkoutPayload,
  defaultPayload,
  schedulePayload,
  startTrialPayload,
  viewContentPayload,
} from './facebook-web.constants';
import { Functions, httpsCallable } from '@angular/fire/functions';

@Injectable({
  providedIn: 'root',
})
export class FacebookWebEventsService {
  private functions = inject(Functions);

  createEventPayload(eventType: string): Record<string, unknown> {
    let updatedPayload: Record<string, unknown>;

    switch (eventType) {
      case 'StartTrial':
        updatedPayload = {
          ...startTrialPayload,
          event_id: `StartTrial-${+new Date()}`,
        };
        break;
      case 'Subscribe':
        updatedPayload = {
          ...defaultPayload,
          event_id: `Subscribe-${+new Date()}`,
        };
        break;
      case 'ViewContent':
        updatedPayload = {
          ...viewContentPayload,
          event_id: `ViewContent-${+new Date()}`,
        };
        break;
      case 'Schedule':
        updatedPayload = {
          ...schedulePayload,
          event_id: `Schedule-${+new Date()}`,
        };
        break;
      case 'InitiateCheckout':
        updatedPayload = {
          ...checkoutPayload,
          event_id: `InitiateCheckout-${+new Date()}`,
          event_time: Math.floor(Date.now() / 1000),
        };
        break;
      default:
        return {};
    }

    return {
      ...updatedPayload,
      event_time: Math.floor(Date.now() / 1000),
    };
  }

  async logEvent(eventType: string): Promise<void> {
    const payload = this.createEventPayload(eventType);
    if (!Object.keys(payload).length) return;

    console.log('Event payload: ', payload);

    const fbq = (
      window as Window & {
        fbq?: (
          action: string,
          event: string,
          parameters?: unknown,
          options?: { eventID?: string },
        ) => void;
      }
    ).fbq;
    if (fbq) {
      const eventId = payload['event_id'];
      fbq(
        'track',
        eventType,
        payload['custom_data'],
        typeof eventId === 'string' ? { eventID: eventId } : undefined,
      );
    } else {
      console.warn('Meta Pixel is not available; sending the server event only.');
    }

    const sendFacebookEvent = httpsCallable(this.functions, 'facebookEvent');
    try {
      await sendFacebookEvent(payload);
    } catch (error) {
      console.error('Unable to send Facebook Conversions API event.', error);
    }
  }
}
